import { render, staticRenderFns } from "./mAlerts.vue?vue&type=template&id=c88c1914&"
import script from "./mAlerts.vue?vue&type=script&lang=js&"
export * from "./mAlerts.vue?vue&type=script&lang=js&"
import style0 from "./mAlerts.vue?vue&type=style&index=0&id=c88c1914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports